import { RelType } from './LinkUtils.js';
export var StudentAssignmentStatus;
(function (StudentAssignmentStatus) {
    StudentAssignmentStatus["NOT_STARTED"] = "NOT_STARTED";
    StudentAssignmentStatus["IN_PROGRESS"] = "IN_PROGRESS";
    StudentAssignmentStatus["RETURNED"] = "RETURNED";
    StudentAssignmentStatus["SUBMITTED"] = "SUBMITTED";
})(StudentAssignmentStatus || (StudentAssignmentStatus = {}));
export var StudentAssignmentOwner;
(function (StudentAssignmentOwner) {
    StudentAssignmentOwner["Any"] = "ANY";
    StudentAssignmentOwner["Self"] = "SELF";
})(StudentAssignmentOwner || (StudentAssignmentOwner = {}));
